export default __webpack_public_path__ + "static/media/kir.269edcfc.jpg";